import { util } from 'echarts/core';
import type StandardChart from './StandardChart';
import type { Option } from './option';
import { debug } from '../util/debug';
import { type Token, type OptionToken, parseToken } from './themeToken';

export type ThemeParser = (option: Option, chart: StandardChart, optionToken: OptionToken) => void;

/**
 * 解析顺序
 * * token -> optionToken -> option
 */
export type Theme = {
  /** 主题名称 */
  name: string;
  /** 主题配置项解析器 */
  parsers?: ThemeParser[];
  /** 主题 token 配置集合 */
  token?: Token;
  /**
   * FIXME
   * 主题 token 集合解析后配置项 token 集合 */
  presetOptionToken?: OptionToken;
};

// 主题缓存
const themeStorage: Map<Theme['name'], Theme> = new Map();

export function getTheme(themeName: string) {
  const result = themeStorage.get(themeName);

  if (typeof result === 'undefined') {
    throw new Error(`there is not a theme named "${themeName}". must register theme config first.`);
  }

  return result;
}

export function registerTheme(theme: Theme) {
  debug('register theme: %s %o', theme);

  if (themeStorage.has(theme.name)) {
    console.warn(`theme "${theme.name}" has been registered, will override it.`);
  }

  themeStorage.set(theme.name, theme);
}

export function parseThemeToken(theme: Theme, override: Omit<Theme, 'name'> = {}) {
  const tokens = { ...(theme.token || {}), ...(override.token || {}) };

  // FIXME 后续去掉 presetOptionToken
  return util.merge(util.clone(theme?.presetOptionToken || {}), parseToken(tokens));
}
